import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NamesToUpdateService } from '../services/raintree/Transmission/names-to-update.service';
import { NamesToUpdateResponse } from '../services/raintree/interfaces/names-to-update.interface';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MasterSearchDialogComponent } from './master-search-dialog/master-search-dialog.component';
import { MasterSearchTransmissionService } from '../services/raintree/Transmission/master-search.service';

import { AreYouUpdatedDialogComponent } from './are-you-updated-dialog/are-you-updated-dialog.component';
import { AreYouUpdatedService } from '../services/raintree/Transmission/are-you-updated.service';
import { AreYouUpdatedResponse } from '../services/raintree/interfaces/are-you-updated.interface';
import { FWAssignDialogComponent } from './fw-assign-dialog/fw-assign-dialog.component';
import { EditDetailsDialogComponent } from './edit-details-dialog/edit-details-dialog.component';
import { FormsModule } from '@angular/forms';
import { DpLoaderComponent } from '../common-component/dp-loader/dp-loader.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonUtilService } from '../services/common-util/common-util.service';
import {
  MatBottomSheet,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { AreYouUpdatedBottomSheetComponent } from './are-you-updated-bottom-sheet/are-you-updated-bottom-sheet.component';
import { EditDetailsBottomSheetComponent } from './edit-details-bottom-sheet/edit-details-bottom-sheet.component';
import { MasterSearchBottomSheetComponent } from './master-search-bottom-sheet/master-search-bottom-sheet.component';
import { LoaderComponent } from '../common-component/loader/loader.component';
import { ToastrService } from 'ngx-toastr';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { deleteRowData } from '../services/common/utils';
import { UserPickingsService } from '../services/raintree/Transmission/user-pickings.service';
import { Router } from '@angular/router';
import { DpnfPopupComponent } from '../views/common/dpnf/dpnf-popup/dpnf-popup.component';
import { AppConfigService } from '../services/config/app-config.service';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'names-to-update',
  standalone: true,
  templateUrl: './names-to-update.component.html',
  styleUrls: [
    './names-to-update.component.scss',
    '../../styles/_dropdown.scss',
  ],
  imports: [
    CommonModule,
    FormsModule,
    DpLoaderComponent,
    MatDialogModule,
    MatTooltipModule,
    MatBottomSheetModule,
    LoaderComponent,
    InfiniteScrollModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
  ],
})
export class NamesToUpdateComponent implements OnInit {
  districtName!: string;
  stateName!: string;
  namesToUpdateRecords!: any[];
  responseData!: any[];
  resData: any = [];
  selectedChip: string | null = 'notAssigned';
  memberName!: string;
  tempData!: any;
  address!: string;
  pincode!: string;
  isLoader: boolean = false;
  queryParamsObj: any = {};
  public isMobile: boolean = false;
  isLoading: boolean = false;
  pageNo = 1;
  pageSize = 4000;
  selectedState: string = '';
  selectedDistrict: string = '';
  states: string[] = [];
  districts: { [key: string]: string[] } = {};
  toggleFilter: boolean = false;
  noDataFound: boolean = false;
  allPerm: any = {}
  constructor(
    private _namesToUpdateService: NamesToUpdateService,
    private _dialog: MatDialog,
    private _areYouUpdatedService: AreYouUpdatedService,
    private isMobileservice: CommonUtilService,
    private _bottomSheet: MatBottomSheet,
    private toaster: ToastrService,
    private _pickUser: UserPickingsService,
    private router: Router,
    private _appConfig: AppConfigService
  ) { }

  ngOnInit(): void {
    this.isMobile = this.isMobileservice.isMobileDevice();
    this.allPerm = this._appConfig.fetchPermissionv3ByViewName();
    this.getStateList();
    if (this.states.length > 0) {
      this.selectedState = this.states[0];
    }
    if (this.districts[this.selectedState].length > 0) {
      this.selectedDistrict = this.districts[this.selectedState][0];
    }
    this.fetchPhilRecords(true);
  }

  fetchPhilRecords(isStart: boolean) {
    if (this.selectedState == '') {
      this.noDataFound = true;
      return;
    }
    // this.districtName = localStorage.getItem('district')!;
    // this.stateName = localStorage.getItem('state')!;
    if (!isStart) {
      this.pageNo += 1;
    } else {
      this.namesToUpdateRecords = [];
      this.pageNo = 1;
    }

    this.queryParamsObj = {
      uiState: this.selectedState,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
    };
    if (this.selectedDistrict != '') {
      this.queryParamsObj['uiDistrict'] = this.selectedDistrict;
    }

    if (this.selectedChip === 'notAssigned') {
      this.queryParamsObj['assigned'] = false;
    } else if (this.selectedChip === 'assigned') {
      this.queryParamsObj['assigned'] = true;
    }
    this._namesToUpdateService.fetchPhilRecords(this.queryParamsObj).subscribe({
      next: (response: NamesToUpdateResponse) => {
        // console.log('&',typeof response.data[0].serialNo);
        let RespData = response.data.map((item) => {
          let lsId = localStorage.getItem('actionMemberId');
          // console.log('local storage serialNo',lsId);

          if (item.id === lsId) {
            item.assignEnabled = true;
          } else {
            item.assignEnabled = false;
          }
          return item;
        });
        this.isLoader = false;
        this.isLoading = false;
        this.namesToUpdateRecords = [...this.namesToUpdateRecords, ...RespData];
        this.tempData = this.namesToUpdateRecords;
      },
      error: (error) => {
        // console.log(error)
        this.isLoader = false;
        this.isLoading = false;
        this.toaster.clear();
        this.toaster.error(error);
      },
    });
  }

  onStateChange() {
    // this.fetchPhilRecords(true);
  }
  onDistrictChange() {
    this.fetchPhilRecords(true);
  }
  clearDistrictSelection() {
    this.selectedDistrict = '';
  }

  getStateList() {
    const countryPerm = this.allPerm['INDIA'];
    if (countryPerm.allStatesPerm.length > 0) {
      // fetch all States (not required for names to update)
    }
    else {
      Object.entries(countryPerm.statePerms).forEach(([state, stateData]: [any, any]) => {
        this.states.push(state);
        this.districts[state] = [];
        if (stateData.allDistrictsPerm.length > 0) {
          // fetch all Districts (not required for names to update)
        }
        else {
          Object.entries(stateData.districtPerms).forEach(([district, districtData]) => {
            this.districts[state].push(district);
          })
        }
      })
    }
  }

  // toggleFilterOptions() {
  //   this.toggleFilter = !this.toggleFilter;
  // }

  storeMemberIdInLocalStorage(memberId: string): void {
    localStorage.setItem('selectedMemberId', memberId);
  }

  userPicker(memId: string, user_action?: string) {
    if (memId !== localStorage.getItem('selectedMemberId')) {
      let payLoad = {};
      if (user_action === 'M') {
        if (this.selectedDistrict != '') {
          payLoad = {
            memCode: memId,
            userAction: user_action,
            uiState: this.selectedState,
            uiDistrict: this.selectedDistrict,
          };
        } else {
          payLoad = {
            memCode: memId,
            userAction: user_action,
            uiState: this.selectedState,
          };
        }
      } else {
        if (this.selectedDistrict != '') {
          payLoad = {
            memCode: memId,
            uiState: this.selectedState,
            uiDistrict: this.selectedDistrict,
          };
        } else {
          payLoad = {
            memCode: memId,
            uiState: this.selectedState,
          };
        }
      }

      this._pickUser.pickUser(memId, payLoad).subscribe({
        next: (response: any) => {
          console.log(response);
          this.storeMemberIdInLocalStorage(memId);
          if (user_action === 'M') {
            localStorage.setItem('actionMemberId', memId);
            this.enableAssignButton(memId);
          }
        },
        error: (error: any) => {
          console.log(error);
          this.toaster.clear();
          this.toaster.error(error);
        },
      });
    } else if (
      localStorage.getItem('actionMemberId') != memId &&
      user_action == 'M'
    ) {
      let payLoad = {};
      if (this.selectedDistrict != '') {
        payLoad = {
          memCode: memId,
          userAction: user_action,
          uiState: this.selectedState,
          uiDistrict: this.selectedDistrict,
        };
      } else {
        payLoad = {
          memCode: memId,
          userAction: user_action,
          uiState: this.selectedState,
        };
      }

      this._pickUser.pickUserAction(memId, payLoad).subscribe({
        next: (response: any) => {
          console.log(response);
          localStorage.setItem('actionMemberId', memId);
          this.enableAssignButton(memId);
        },
        error: (error: any) => {
          console.log(error);
          this.toaster.clear();
          this.toaster.error(error);
        },
      });
    }
  }

  selectChip(chip: string) {
    this.selectedChip = chip;
    this.memberName = this.address = this.pincode = '';
    this.fetchPhilRecords(true);
  }

  onRowMouseOver(row: any) {
    row.showExpandText = true;
  }

  onRowMouseOut(row: any) {
    row.showExpandText = false;
  }

  onRowClick(selectedRow: any) {
    this.namesToUpdateRecords.forEach((row: { isExpanded: boolean }) => {
      if (row !== selectedRow) {
        row.isExpanded = false;
      }
    });
    selectedRow.isExpanded = !selectedRow.isExpanded;
  }

  collapseRow(event: MouseEvent, row: any) {
    event.stopPropagation();
    row.isExpanded = false;
  }

  onSearchMemberName(event: any) {
    console.log('&', this.tempData);
    this.namesToUpdateRecords = this.tempData;
    console.log('&', this.namesToUpdateRecords);
    if (event != '') {
      this.namesToUpdateRecords = this.namesToUpdateRecords.filter((record) =>
        record.mNm?.toLowerCase().includes(this.memberName?.toLowerCase())
      );
    } else {
      this.namesToUpdateRecords = this.tempData;
    }
  }

  onSearchAddressName(event: any) {
    this.namesToUpdateRecords = this.tempData;
    if (event != '') {
      this.namesToUpdateRecords = this.namesToUpdateRecords.filter((record) =>
        record.addr?.toLowerCase().includes(this.address?.toLowerCase())
      );
    } else {
      this.namesToUpdateRecords = this.tempData;
    }
  }

  onSearchPincode(event: any) {
    this.namesToUpdateRecords = this.tempData;
    if (event != '') {
      this.namesToUpdateRecords = this.namesToUpdateRecords.filter((record) =>
        record.addr?.toLowerCase().includes(this.pincode?.toLowerCase())
      );
    } else {
      this.namesToUpdateRecords = this.tempData;
    }
  }

  openMasterSearchDialog(
    memberId: string,
    name: string,
    ritwikName: string,
    address: string
  ) {
    this.userPicker(memberId, 'M');
    const dialogRef = this._dialog.open(MasterSearchDialogComponent, {
      width: '97vw',
      maxWidth: '100vw',
      height: 'calc(100vh - 80px)',
      data: {
        name: name,
        ritwikName: ritwikName,
        address: address,
        memberId: memberId,
        uiState: this.selectedState,
        uiDistrict: this.selectedDistrict,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        this.tempData.forEach((elm: any) => {
          if (elm.id === memberId) {
            elm.serialNo = result;
          }
        });
      }
    });
  }

  openAreYouUpdatedDialog(event: Event, familyCode: string) {
    event.stopPropagation();
    this.isLoading = true;
    let reqData: any = { familyCode: familyCode };
    this._areYouUpdatedService.getDetailsByFC(reqData).subscribe({
      next: (response: AreYouUpdatedResponse) => {
        this.resData = response['data'].memberList;
        this.isLoading = false;
        this._dialog.open(AreYouUpdatedDialogComponent, {
          width: '80vw',
          maxWidth: '100vw',
          height: 'calc(100vh - 150px)',
          data: this.resData,
        });
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
      },
    });
  }

  openDpnf(row: any) {
    console.log(row);
    let firstName: string = '';
    let middleName: string = '';
    let lastName: string = '';

    let fullname = row.mNm.trim().split(/\s+/);
    if (fullname.length === 1) {
      firstName = fullname[0];
    } else if (fullname.length === 2) {
      firstName = fullname[0];
      lastName = fullname[1];
    } else if (fullname.length > 2) {
      firstName = fullname[0];
      middleName = fullname.slice(1, -1).join(' ');
      lastName = fullname.slice(-1)[0];
    }

    let rowData = {
      dikshyarthiFName: firstName,
      dikshyarthiMName: middleName,
      dikshyarthiLName: lastName,
      ritwickName: row.rNm,
      contactNumber: row.contact,
      new: true,
    };
    // this.router.navigate([RequestMapper.DPNF_LIST]);
    const dialogRef = this._dialog.open(DpnfPopupComponent, {
      data: rowData,
      width: '85vw',
      maxWidth: '100vw',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log(result);
      }
    });
  }

  openFWAssignDialog(memCode: string) {
    const dialogRef = this._dialog.open(FWAssignDialogComponent, {
      data: {
        memCodes: memCode,
        selectedState: this.selectedState,
        selectedDistrict: this.selectedDistrict,
      },
    });
    console.log(memCode);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        deleteRowData(this.tempData, 'id', memCode);
        // this.tempData=this.namesToUpdateRecords;
      }
    });
  }

  enableAssignButton(memId: string): void {
    this.namesToUpdateRecords.forEach((row) => {
      row.assignEnabled = row.id === memId;
    });
    console.log(this.namesToUpdateRecords);
    this.tempData = this.namesToUpdateRecords;
  }

  openEditDetailsDialog(row: any) {
    this.userPicker(row.id);
    const dialogRef = this._dialog.open(EditDetailsDialogComponent, {
      data: row,
    });
    dialogRef.afterClosed().subscribe((result?: any) => {
      console.log(result);
      if (result) {
        this.tempData.forEach((elm: any) => {
          if (elm.id === row.id) {
            elm.serialNo = result.dpwMemKey;
            elm.contact = result.contactNo;
            elm.addr = result.address;
          }
        });
        // this.namesToUpdateRecords=this.tempData;
      }
    });
  }

  openBottomSheetfc(familyCode: string, event: any): void {
    event.preventDefault();
    this.isLoading = true;
    let reqData: any = { familyCode: familyCode };
    this._areYouUpdatedService.getDetailsByFC(reqData).subscribe({
      next: (response: AreYouUpdatedResponse) => {
        this.resData = response['data'].memberList;
        this.isLoading = false;
        this._bottomSheet.open(AreYouUpdatedBottomSheetComponent, {
          data: this.resData,
        });
      },

      error: (error) => {
        this.isLoading = false;
        console.log(error), this.toaster.error(error.message);
      },
    });
  }

  openEditDetailsDialogMobile(row: any): void {
    this.userPicker(row.id);
    const btnsheet = this._bottomSheet.open(EditDetailsBottomSheetComponent, {
      data: row,
    });
    btnsheet.afterDismissed().subscribe((result) => {
      if (result) {
        this.tempData.forEach((elm: any) => {
          if (elm.id === row.id) {
            elm.serialNo = result.dpwMemKey;
            elm.contact = result.contactNo;
            elm.addr = result.address;
          }
        });
        // this.namesToUpdateRecords=this.tempData;
      }
    });
  }

  openMasterSearchDialogMobile(
    memberId: string,
    name: string,
    ritwikName: string,
    address: string
  ): void {
    this.userPicker(memberId, 'M');
    const btnsheet = this._bottomSheet.open(MasterSearchBottomSheetComponent, {
      data: {
        name: name,
        ritwikName: ritwikName,
        address: address,
        memberId: memberId,
      },
    });

    btnsheet.afterDismissed().subscribe((result) => {
      // if(result){
      this.tempData.forEach((elm: any) => {
        if (elm.id === memberId) {
          elm.serialNo = result;
        }
      });
      // }
    });
  }
}
